module.exports = __webpack_public_path__ + "img/img_defult.1fa5b81b.png";